import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconThumbsDown: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_458_1095)">
                        <path
                            d="M10.9167 9.16669V2.16669"
                            stroke="currentColor"
                            strokeWidth="1.15"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6.25 11.57L6.83333 9.16669H3.4325C3.25138 9.16669 3.07275 9.12452 2.91075 9.04352C2.74875 8.96252 2.60784 8.84492 2.49917 8.70002C2.3905 8.55513 2.31705 8.38692 2.28465 8.20872C2.25225 8.03052 2.26179 7.84723 2.3125 7.67335L3.67167 3.00669C3.74235 2.76435 3.88972 2.55148 4.09167 2.40002C4.29361 2.24856 4.53924 2.16669 4.79167 2.16669H12.6667C12.9761 2.16669 13.2728 2.2896 13.4916 2.5084C13.7104 2.72719 13.8333 3.02393 13.8333 3.33335V8.00002C13.8333 8.30944 13.7104 8.60619 13.4916 8.82498C13.2728 9.04377 12.9761 9.16669 12.6667 9.16669H11.0567C10.8396 9.1668 10.6269 9.22746 10.4424 9.34185C10.258 9.45624 10.1091 9.61981 10.0125 9.81419L8 13.8334C7.72491 13.8299 7.45415 13.7644 7.20795 13.6417C6.96174 13.5189 6.74646 13.3421 6.57818 13.1245C6.4099 12.9068 6.29298 12.654 6.23615 12.3848C6.17933 12.1156 6.18406 11.8371 6.25 11.57Z"
                            stroke="currentColor"
                            strokeWidth="1.15"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_458_1095">
                            <rect width="14" height="14" fill="white" transform="translate(1 1)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_458_1099)">
                        <path
                            d="M13.3333 11.3333V3.33331"
                            stroke="currentColor"
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8 14.08L8.66667 11.3333H4.78C4.57301 11.3333 4.36886 11.2851 4.18372 11.1925C3.99857 11.1 3.83753 10.9656 3.71333 10.8C3.58914 10.6344 3.5052 10.4421 3.46817 10.2385C3.43115 10.0348 3.44204 9.82536 3.5 9.62665L5.05333 4.29331C5.13411 4.01636 5.30254 3.77308 5.53333 3.59998C5.76413 3.42688 6.04484 3.33331 6.33333 3.33331H15.3333C15.687 3.33331 16.0261 3.47379 16.2761 3.72384C16.5262 3.97389 16.6667 4.31302 16.6667 4.66665V9.99998C16.6667 10.3536 16.5262 10.6927 16.2761 10.9428C16.0261 11.1928 15.687 11.3333 15.3333 11.3333H13.4933C13.2453 11.3334 13.0022 11.4028 12.7914 11.5335C12.5806 11.6642 12.4104 11.8512 12.3 12.0733L10 16.6666C9.68562 16.6628 9.37617 16.5879 9.0948 16.4476C8.81342 16.3073 8.56738 16.1052 8.37506 15.8565C8.18275 15.6078 8.04912 15.3188 7.98418 15.0112C7.91923 14.7036 7.92464 14.3852 8 14.08Z"
                            stroke="currentColor"
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_458_1099">
                            <rect width="16" height="16" fill="white" transform="translate(2 2)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_458_1103)">
                        <path
                            d="M15.75 13.5V4.5"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9.75 16.59L10.5 13.5H6.1275C5.89463 13.5 5.66496 13.4458 5.45668 13.3416C5.2484 13.2375 5.06722 13.0863 4.9275 12.9C4.78778 12.7137 4.69335 12.4974 4.65169 12.2683C4.61004 12.0392 4.6223 11.8036 4.6875 11.58L6.435 5.58C6.52588 5.26843 6.71536 4.99473 6.975 4.8C7.23464 4.60527 7.55044 4.5 7.875 4.5H18C18.3978 4.5 18.7794 4.65804 19.0607 4.93934C19.342 5.22064 19.5 5.60218 19.5 6V12C19.5 12.3978 19.342 12.7794 19.0607 13.0607C18.7794 13.342 18.3978 13.5 18 13.5H15.93C15.6509 13.5001 15.3774 13.5781 15.1403 13.7252C14.9031 13.8723 14.7117 14.0826 14.5875 14.3325L12 19.5C11.6463 19.4956 11.2982 19.4114 10.9816 19.2536C10.6651 19.0957 10.3883 18.8684 10.1719 18.5886C9.95559 18.3088 9.80526 17.9837 9.7322 17.6376C9.65913 17.2915 9.66522 16.9334 9.75 16.59Z"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_458_1103">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
